import { render } from "./BudgetBig.vue?vue&type=template&id=019af62b&ts=true"
import script from "./BudgetBig.vue?vue&type=script&lang=ts"
export * from "./BudgetBig.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__